module.exports = __webpack_public_path__ + "static/media/FC_Smaller.efb61565.png";